import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import {
  PRE_ACTIVATION_FIELD_AGENCY_AD_PLATFORMS,
  PRE_ACTIVATION_FIELD_AGENCY_MODULES,
  PRE_ACTIVATION_HINT_AGENCY_MODULES,
} from "../../../i18n/keysTranslations";
import {
  AGENCY_AD_PLATFORM_OPTIONS,
  AGENCY_MODULE_OPTIONS,
  hasPaidMediaModule,
  mapTranslatedOptions,
} from "../agencyFormConfig";
import CheckGroupField from "../components/CheckGroupField";
import ReadOnlySectionGrid from "../components/ReadOnlySectionGrid";

const AgencyBasicsSection = ({
  control,
  readOnly,
  agencyModules = [],
}) => {
  const { t } = useTranslation();
  const moduleOptions = useMemo(
    () => mapTranslatedOptions({ options: AGENCY_MODULE_OPTIONS, t }),
    [t]
  );
  const platformOptions = useMemo(
    () => mapTranslatedOptions({ options: AGENCY_AD_PLATFORM_OPTIONS, t }),
    [t]
  );
  const showAdPlatforms = hasPaidMediaModule(agencyModules);

  return (
    <ReadOnlySectionGrid readOnly={readOnly}>
      <CheckGroupField
        name="agencyModules"
        label={t(PRE_ACTIVATION_FIELD_AGENCY_MODULES)}
        hint={t(PRE_ACTIVATION_HINT_AGENCY_MODULES)}
        required
        options={moduleOptions}
        control={control}
        readOnly={readOnly}
      />
      {showAdPlatforms ? (
        <CheckGroupField
          name="agencyAdPlatforms"
          label={t(PRE_ACTIVATION_FIELD_AGENCY_AD_PLATFORMS)}
          required
          options={platformOptions}
          control={control}
          readOnly={readOnly}
        />
      ) : null}
    </ReadOnlySectionGrid>
  );
};

export default AgencyBasicsSection;
